/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PromptScheduleModel } from '../../models/prompt-schedule-model';

export interface SavePromptSchedule$Params {
      body?: PromptScheduleModel
}

export function SavePromptSchedule(http: HttpClient, rootUrl: string, params?: SavePromptSchedule$Params, context?: HttpContext): Observable<StrictHttpResponse<PromptScheduleModel>> {
  const rb = new RequestBuilder(rootUrl, SavePromptSchedule.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PromptScheduleModel>;
    })
  );
}

SavePromptSchedule.PATH = '/api/Supervisor/SavePromptSchedule';
